module.exports = __webpack_public_path__ + "img/validado.a487b708.svg";